var _use, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    fill: "#f2f2f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    fill: "#fdc400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h8v16H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M7.092 1.97a1 1 0 0 1 1.816 0l1.115 2.416a1 1 0 0 0 .79.574l2.643.313A1 1 0 0 1 14.017 7l-1.954 1.807a1 1 0 0 0-.302.929l.52 2.6a1 1 0 0 1-1.469 1.067l-2.322-1.3a1 1 0 0 0-.977 0l-2.322 1.3a1 1 0 0 1-1.469-1.067l.52-2.6a1 1 0 0 0-.302-.929L1.983 7a1 1 0 0 1 .561-1.727l2.643-.313a1 1 0 0 0 .79-.574L7.092 1.97z"
  }))));
};
export default SvgHalfStar;